/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InsiderService {
    /**
     * Get Amount Events Created
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getAmountEventsCreatedInsiderEventsCreatedGet(): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insider/events/created',
        });
    }
    /**
     * Get Amount Events Last Edited
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getAmountEventsLastEditedInsiderEventsLastEditedGet(): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insider/events/last_edited',
        });
    }
    /**
     * Get Amount Lineups Created
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getAmountLineupsCreatedInsiderLineupCreatedGet(): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insider/lineup/created',
        });
    }
    /**
     * Get Amount Lineups Last Edited
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getAmountLineupsLastEditedInsiderLineupLastEditedGet(): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insider/lineup/last_edited',
        });
    }
}
